import Radio, { RadioGroup } from '@veeva/corgix/radio';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import {
    customerStatFilterStatInputCSS,
    customerStatFilterStatInputDisabledCSS,
    filterSelectionStatInputContainerCSS,
} from './styles/FilterSelectionMenu.styles';

export default function FilterSelectionStatInput({
    stat,
    handleSetFilters,
    filterRowId,
    filter,
    operator,
    filterStatType,
    setFilterStatType,
    disabled = false,
}) {
    const [statValue, setStatValue] = useState('');
    const handleInputChange = (e) => {
        const number = e.target.value;
        setStatValue(number);
        let newStatFilter;
        let label;
        if (filter?.statFilter) {
            newStatFilter = {
                operator: filter.statFilter.operator,
                statKey: filter.statFilter.statKey,
                statLabel: filter.statFilter.statLabel,
                filterType: filter.statFilter.filterType,
                number,
            };
            label = `Stats ${filter.statFilter.statKey}`;
        } else {
            newStatFilter = {
                number,
                statKey: stat.statKey,
                operator: operator || 'EQUALS',
                filterType: filterStatType,
                statLabel: stat.label,
            };
            label = `Stats ${stat.statKey}`;
        }
        handleSetFilters(
            filterRowId,
            !number || number === '' ? null : { statFilter: newStatFilter },
            !(number || number === ''),
            label,
        );
    };
    const handleStatTypeChange = (e, value) => {
        setFilterStatType(value);
        let newStatFilter;
        let label;
        let number;
        if (filter?.statFilter) {
            newStatFilter = {
                operator: filter.statFilter.operator,
                statKey: filter.statFilter.statKey,
                statLabel: filter.statFilter.statLabel,
                filterType: value,
                number: filter.statFilter.number,
            };
            label = `Stats ${filter.statFilter.statKey}`;
            number = filter.statFilter.number;
        } else {
            newStatFilter = {
                filterType: value,
                statKey: stat.statKey,
                operator: 'EQUALS',
                statLabel: stat.label,
            };
            label = `Stats ${stat.statKey}`;
        }
        handleSetFilters(
            filterRowId,
            number ? { statFilter: newStatFilter } : null,
            !!number,
            label,
        );
    };

    useEffect(() => {
        if (filter?.statFilter) {
            setStatValue(filter.statFilter.number);
            setFilterStatType(filter.statFilter.filterType);
        } else {
            setFilterStatType(filterStatType);
            setStatValue('');
        }
    }, [filter, filterStatType, setFilterStatType]);

    const renderRadioGroups = () => {
        if (stat?.type === 'AVG') {
            return (
                <RadioGroup
                    disabled={disabled}
                    value={filterStatType}
                    onChange={handleStatTypeChange}
                    inline
                >
                    <Radio label="Daily" value="DAILY" />
                    <Radio label="Average" value="AVG" />
                </RadioGroup>
            );
        }
        if (stat?.type === 'TOTAL') {
            return (
                <RadioGroup
                    disabled={disabled}
                    value={filterStatType}
                    onChange={handleStatTypeChange}
                    inline
                >
                    <Radio label="Daily" value="DAILY" />
                    <Radio label="Max" value="MAX" />
                </RadioGroup>
            );
        }
        return (
            <RadioGroup
                disabled={disabled}
                value={filterStatType}
                onChange={handleStatTypeChange}
                inline
            >
                <Radio label="Daily" value="DAILY" />
                <Radio label="Sum" value="SUM" />
                <Radio label="Average" value="AVG" />
            </RadioGroup>
        );
    };
    return (
        <div css={filterSelectionStatInputContainerCSS}>
            <input
                value={statValue}
                onChange={handleInputChange}
                required
                css={
                    disabled
                        ? customerStatFilterStatInputDisabledCSS
                        : customerStatFilterStatInputCSS
                }
                type="number"
                disabled={disabled}
            />
            {renderRadioGroups()}
        </div>
    );
}
FilterSelectionStatInput.propTypes = {
    disabled: PropTypes.bool,
    filter: PropTypes.shape({
        appKeys: PropTypes.arrayOf(PropTypes.string),
        customerIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        customerSizes: PropTypes.arrayOf(PropTypes.string),
        industries: PropTypes.arrayOf(PropTypes.string),
        podNames: PropTypes.arrayOf(PropTypes.string),
        regions: PropTypes.arrayOf(PropTypes.string),
        segments: PropTypes.arrayOf(PropTypes.string),
        statFilter: PropTypes.shape({
            filterType: PropTypes.string,
            number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            operator: PropTypes.string,
            statKey: PropTypes.string,
            statLabel: PropTypes.string,
        }),
        vaultBasics: PropTypes.string,
        vaultSizes: PropTypes.arrayOf(PropTypes.string),
    }),
    filterRowId: PropTypes.number,
    filterStatType: PropTypes.string,
    handleSetFilters: PropTypes.func,
    operator: PropTypes.string,
    setFilterStatType: PropTypes.func,
    stat: PropTypes.shape({
        compoundKey: PropTypes.string,
        label: PropTypes.string,
        statKey: PropTypes.string,
        type: PropTypes.string,
    }),
};
